module.exports = __webpack_public_path__ + "img/wallet_03_decentralized.91b0c533.png";